import React from 'react';
import styled from 'styled-components';

import Card from '../Card';
import Button from '../Button';
import { T } from '../../components/I18n';

function ActionCard({title, tags, description, action, active, ...props}) {
  if (action.type === Button) {
    // Force action buttons to be secondary according to the style guide.
    action = React.cloneElement(action, {secondary: true});
  }

  return (
    <Card active={active} {...props}>
      <Header active={active}>
        <H1><T noTranslate>{title}</T></H1>
        {tags && <Tags><T noTranslate>{tags}</T></Tags>}
        {description && <Description><T noTranslate>{description}</T></Description>}
      </Header>
      <Card.Footer end={action} />
    </Card>
  );
}

const Header = styled.div`
  padding: ${props => props.active ? '1.75rem' : '1.875rem'};
`;

const H1 = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Tags = styled.div`
  margin-top: 0.125rem;
`;

const Tag = styled(props => <Button {...props} blank />)`
  background: ${props => props.blank ? 'transparent' : '#0049ee'};
  color: ${props => props.blank ? '#0049ee' : '#fff'};
  padding: ${props => props.blank ? '0.5rem 0' : '0.5rem 1rem'};
  line-height: 1;
  margin-right: 0.5rem;
  border-radius: 1rem;
  margin-top: 0.5rem;
`;

const Description = styled.p`
  margin: 0;
  margin-top: 0.625rem;
  font-weight: 400;
  line-height: 1.5;
`;

ActionCard.Tag = Tag;
export default ActionCard;